var _rect, _rect2, _path, _circle, _circle2, _circle3, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRailsExpanded = function SvgRailsExpanded(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7,
    viewBox: "0 0 24 24",
    className: "svgr-icon"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 14,
    x: 3,
    y: 5,
    rx: 2.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 9.6,
    height: 14,
    x: 3.4,
    y: 5,
    fill: "currentColor",
    stroke: "none",
    opacity: 0.3,
    rx: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 5v14"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.9,
    cy: 9,
    r: 1.1,
    fill: "currentColor",
    stroke: "none"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.9,
    cy: 12,
    r: 1.1,
    fill: "currentColor",
    stroke: "none"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.9,
    cy: 15,
    r: 1.1,
    fill: "currentColor",
    stroke: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3 9h3.2m-3.2 3h3.2m-3.2 3h3.2"
  })));
};
export default SvgRailsExpanded;